"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const snap_ui_1 = require("@teamsnap/snap-ui");
const snap_ui_2 = require("@teamsnap/snap-ui");
const snap_ui_input_connector_1 = __importDefault(require("components/form/snap-ui-input-connector"));
const React = __importStar(require("react"));
const redux_form_1 = require("redux-form");
class FormSectionProfile extends React.Component {
    render() {
        return (React.createElement("div", { id: "profile-information", className: "sui-border sui-p-4 sui-mb-2 sui-border-neutral-border sui-bg-neutral-background sui-rounded" },
            React.createElement("h3", { className: "sui-heading-md sui-font-normal sui-text-gray-40" }, "Profile Information"),
            React.createElement("div", { id: "profile-settings-form", className: "" },
                React.createElement(redux_form_1.FormSection, { name: "profile" },
                    React.createElement("div", { className: "sui-mb-2" },
                        React.createElement(snap_ui_1.Label, { htmlFor: "person-photo", className: "sui-mb-2" }, "Profile picture"),
                        React.createElement("div", { className: "sui-flex sui-justify-center sui-items-center" },
                            React.createElement(snap_ui_1.Avatar, { type: "placeholder", size: "large", className: "sui-mr-1" }),
                            React.createElement(snap_ui_1.LabelButton, { icon: "edit", labelText: "Upload profile picture", variantType: "tertiary" }))),
                    React.createElement(redux_form_1.Field, { id: "firstName", name: "firstName", label: "First Name", required: true, className: "sui-mb-2", component: snap_ui_input_connector_1.default, type: "text", maxLength: 40 }),
                    React.createElement(redux_form_1.Field, { id: "lastName", name: "lastName", label: "Last Name", className: "sui-mb-2", required: true, component: snap_ui_input_connector_1.default, type: "text", maxLength: 40 }),
                    React.createElement(redux_form_1.Field, { id: "gender", name: "gender", label: "Gender", className: "sui-mb-2", required: true, component: snap_ui_input_connector_1.default, type: "select", options: snap_ui_2.GENDER_OPTIONS }),
                    React.createElement(redux_form_1.Field, { id: "birthdate", name: "birthdate", label: "Your date of birth", required: true, component: snap_ui_input_connector_1.default, type: "birthdate" })))));
    }
}
exports.default = FormSectionProfile;
